import React, { useEffect, useState } from "react";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import { message, Spin, DatePicker, Row, Col, Pagination, Select } from "antd";
import { TitleSearch } from "components/SearchWidget/TitleSearch";
import TableWidget from "./TableWidget/TableWidget";
import { showOrderDetailDialog } from "./OrderDetailDialog/showOrderDetailDialog";
import {
  apiGetShopOrderList,
  apiDeleteShopOrder,
} from "services/shopOrderService";
const { RangePicker } = DatePicker;

const STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "new", label: "New" },
  { value: "processing", label: "Processing" },
  { value: "shipped", label: "Shipped" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

function ShopOrderListPage() {
  const [isBusy, setIsBusy] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const loadOrders = () => {
    setIsBusy(true);
    apiGetShopOrderList(currentPage, pageSize, startDate, endDate, statusFilter)
      .then((data) => {
        setIsBusy(false);
        setDataList(data.dataList);
        setSearchList(data.dataList);
        setTotalCount(data.total_count);
      })
      .catch((err) => {
        setIsBusy(false);
        setDataList([]);
        setSearchList([]);
        message.error("Sorry! " + err);
      });
  };

  useEffect(() => {
    loadOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, currentPage, startDate, endDate, statusFilter]);

  const onShowSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(current);
  };
  const onChange = (pageNumber) => setCurrentPage(pageNumber);

  const handleSearch = (searchText) => {
    const t = (searchText || "").toLowerCase();
    const tmpList = dataList.filter(
      (o) =>
        (o.order_no || "").toLowerCase().includes(t) ||
        (o.customer_name || "").toLowerCase().includes(t) ||
        (o.customer_email || "").toLowerCase().includes(t)
    );
    setSearchList([...tmpList]);
  };
  const handleChange = (event) => {
    if (event.target.value === "") setSearchList(dataList);
    else handleSearch(event.target.value);
  };

  const handleDateFilter = (start, end) => {
    setCurrentPage(1);
    setStartDate(start);
    setEndDate(end);
  };

  const onClickDelete = (pInfo) => {
    setIsBusy(true);
    apiDeleteShopOrder(pInfo.id)
      .then(() => {
        setIsBusy(false);
        const updateData = dataList.filter((x) => x.id != pInfo.id);
        setDataList([...updateData]);
        setSearchList([...updateData]);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const onClickView = async (pInfo) => {
    const res = await showOrderDetailDialog({ order: pInfo });
    if (res && res.order_status) {
      const updateData = dataList.map((x) =>
        x.id == pInfo.id ? { ...x, order_status: res.order_status } : x
      );
      setDataList(updateData);
      setSearchList(
        searchList.map((x) =>
          x.id == pInfo.id ? { ...x, order_status: res.order_status } : x
        )
      );
    }
  };

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <h1>Orders</h1>
        <Row align="middle">
          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              Date Filter Period : &nbsp;&nbsp;
              <RangePicker
                size={"default"}
                onChange={(e, date) => {
                  if (date == null) handleDateFilter("", "");
                  else handleDateFilter(date[0], date[1]);
                }}
              />
            </div>
          </Col>
          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <Select
                style={{ width: 180 }}
                value={statusFilter}
                onChange={(v) => {
                  setCurrentPage(1);
                  setStatusFilter(v);
                }}
                options={STATUS_OPTIONS}
              />
            </div>
          </Col>
          <Col flex={"auto"}>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <TitleSearch
                onSearch={handleSearch}
                onChange={handleChange}
                onPressEnter={handleSearch}
              />
            </div>
          </Col>
        </Row>
        <Row justify={"center"} style={{ paddingTop: 16 }}>
          <Col>
            <Pagination
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              onChange={onChange}
              defaultCurrent={1}
              current={currentPage}
              total={totalCount}
              pageSize={pageSize}
            />
          </Col>
        </Row>

        <div style={{ paddingTop: 32 }}>
          <TableWidget
            dataList={searchList}
            onViewAction={onClickView}
            onDeleteAction={onClickDelete}
          />
        </div>
      </Spin>
    </CommonDivWidget>
  );
}

export default ShopOrderListPage;
